import { SidecarSortOption } from '@rematter/frontend-lib-api-client';

import { SidecarRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const sidecarsListQueryAtom = createQueryAtomFactory(
  'settings.sidecarsList',
  (params: {
    ids?: string[];
    facilityId?: string;
    limit?: number;
    offset?: number;
    sorting?: SidecarSortOption[];
  }) => ({
    sidecars: {
      __args: {
        filter: {
          ids: params.ids,
          facilityId: params.facilityId,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        name: true,
        operatingSystem: true,
        operatingSystemVersion: true,
        version: true,
        localIpAddress: true,
        remoteIpAddressV4: true,
        remoteIpAddressV6: true,
        linkSpeedUpstream: true,
        linkSpeedDownstream: true,
        latencyMs: true,
        jitterMs: true,
        peerId: true,
        multiaddrs: true,
        status: true,
        online: true,
        facilityId: true,
        facility: {
          id: true,
          facilityName: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { sidecars: SidecarRecord[]; totalCount: number } => {
      if (!data?.sidecars?.entries) {
        return { sidecars: [], totalCount: 0 };
      }

      return {
        sidecars: data.sidecars.entries.map((entry) => ({
          id: entry.id,
          name: entry.name,
          operatingSystem: entry.operatingSystem,
          operatingSystemVersion: entry.operatingSystemVersion,
          version: entry.version ?? null,
          localIpAddress: entry.localIpAddress ?? null,
          remoteIpAddressV4: entry.remoteIpAddressV4 ?? null,
          remoteIpAddressV6: entry.remoteIpAddressV6 ?? null,
          linkSpeedUpstream: entry.linkSpeedUpstream ?? null,
          linkSpeedDownstream: entry.linkSpeedDownstream ?? null,
          latencyMs: (entry.latencyMs as number) ?? null,
          jitterMs: (entry.jitterMs as number) ?? null,
          peerId: entry.peerId ?? null,
          multiaddrs: (entry.multiaddrs as string[]) ?? [],
          status: entry.status,
          online: entry.online ?? false,
          lastHeartbeatAt: null,
          connectedAt: null,
          facilityId: entry.facilityId,
          facility: entry.facility
            ? {
                id: entry.facility.id,
                name: entry.facility.facilityName,
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(entry.timestamps.createdAt),
            updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
          },
        })),
        totalCount: data.sidecars.page?.total ?? 0,
      };
    },
  },
);
